import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import ComingSoon from '../../../components/uiframeworks/comingSoon';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import DepositsList from '../../../components/finances/deposits/general/list';

type DepositsListPageProps = {
}

const DepositsListPage: React.FC<DepositsListPageProps> = (props: DepositsListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Deposits", [
            {key: "home", icon: faHome, href: "/"},
            {key: "finance", text: 'Finance', href: "/finance"},
            {key: "deposits", text: 'Deposits'}
        ])
    }, []);

    return <Stack>
        <DepositsList />
    </Stack>;
};

export default DepositsListPage;
